import Header from "../components/Header";
import Footer from "../components/Footer";
import "../pages/AboutPage.css";

export default function AboutPage() {
  return (
    <main className="about-main">
      <Header />

      <section className="about-hero-section">
        <div className="about-container">
          <div className="about-header">
            {/* <h1 className="about-title">About Natoshine Pharmaceutical</h1> */}
            <h1 className="about-title" style={{ fontWeight: "700" }}>
              {/* Leading pharmaceutical innovations with a commitment to global healthcare excellence */}
              Dedicated to Bringing Happiness into People’s Lives.
            </h1>
          </div>

          <div className="about-mission-grid">
            <div className="about-mission-content about-vision-card">
              {/* <h2 className="about-section-heading">Our Mission</h2> */}
              <p className="about-text ">
                {/* At Natoshine, we are dedicated to discovering, developing, and delivering innovative pharmaceutical
                solutions that improve the lives of patients. Our mission is to advance healthcare through
                cutting-edge research and unwavering commitment to quality. */}
                Founded in 2019, Natoshine Pharmaceutical Private Limited is one
                of India’s fastest-growing pharmaceutical companies, built on a
                vision to serve humanity with superior healthcare solutions. We
                began as a dynamic ethical marketing firm led by young and
                passionate pharmaceutical professionals.
              </p>
              <p className="about-text ">
                Our journey started with ethical marketing operations across two
                Indian states, where we successfully established a strong
                product presence across multiple therapeutic categories. Over
                the years, we have consistently achieved over 100% year-on-year
                growth, expanding our reach and portfolio to include more than
                23 SKUs across Gynaecology, Gastroenterology, Cardiology,
                Nutraceuticals, Pain Management, and other therapeutic segments.
              </p>
            </div>
            <div className="about-vision-card2">
              <h3 className="about-card-title">OUR EXPERTISE</h3>
              <p className="about-text">
                {/* To be a global leader in pharmaceutical innovation, trusted by healthcare professionals and patients for
                delivering effective, safe, and affordable medicines. */}
                <ul>
                  <li>
                    <span style={{ fontWeight: "700" }}>
                      Therapeutic Areas:-
                    </span>{" "}
                    Gastro, Anti-allergics, Cardiac, Diabetic, NSAIDs, Vitamins
                    & more.
                  </li>
                  <li>
                    <span style={{ fontWeight: "700" }}>Dosage Forms:</span>{" "}
                    Tablets, Capsules, Liquid Suspensions/Syrups
                  </li>
                  <li>
                    <span style={{ fontWeight: "700" }}>
                      Manufacturing Model:
                    </span>{" "}
                    Third-Party and branded ethical marketing
                  </li>
                  <li>
                    <span style={{ fontWeight: "700" }}>Certifications:</span>{" "}
                    W.H.O-G.M.P!
                  </li>
                </ul>
              </p>
            </div>
          </div>

          {/* <div className="about-stats-grid">
            {[
              { value: "500+", label: "Healthcare Partners" },
              { value: "50+", label: "Products" },
              { value: "100+", label: "Countries" },
              { value: "1000+", label: "Team Members" },
            ].map((stat, i) => (
              <div key={i} className="stats-card">
                <p className="stats-value">{stat.value}</p>
                <p className="stats-label">{stat.label}</p>
              </div>
            ))}
          </div> */}

          <div className="about-values-section">
            <h2 className="about-section-heading">Core Values</h2>
            <div className="values-grid">
              {[
                {
                  title: "Integrity",
                  desc: "We display transparency and integrity in all our dealing with internal and external customers,ensuring highest levels of ethical standerds.",
                },
                {
                  title: "Teamwork",
                  desc: "We work as a team in supporting each other in achieving common objectives,and generating highest level of synergy for exponential growth.",
                },
                {
                  title: "Professsionalism",
                  desc: "We display empathy in dealing with subordinates & colleagues to generate positive energy & provide a cultute where each individual can grow to his or her maximum potential",
                },
              ].map((value, i) => (
                <div key={i} className="value-card">
                  <h3 className="value-title">{value.title}</h3>
                  <p className="value-desc">{value.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
